import AxiosClient from "../../../services/axios.services";

class ConfSmartServices {
  getConfSmartEmpleados = (params) =>
    AxiosClient.get("/api/app/EvaluacionObjetivosConfiguracionListaEmpleado/",
      {
        headers: { "Content-Type": "application/json" },
        params: params,
      }
    );
  
  getConfSmart = (params) =>
    AxiosClient.get("/api/app/evaluacion_objetivos_configuracion/",
      {
        headers: { "Content-Type": "application/json" },
        params: params,
      }
    );
  
  getConfSmartById = (id) =>
    AxiosClient.get(`/api/app/evaluacion_objetivos_configuracion/${id}/`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  saveConfSmart = (data) =>
    AxiosClient.post("/api/app/evaluacion_objetivos_configuracion_creacion/",
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
    revisionEmpleadosConfSmart = (data) =>
    AxiosClient.post("/api/app/evaluacion_objetivos_revision_empleados_configuracion/",
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
 /*  editConfSmart = (id, data) =>
    AxiosClient.put(`/api/app/EvaluacionObjetivosConfiguracionListaEmpleado/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  deleteConfSmart = (id) =>
    AxiosClient.delete(`/api/app/EvaluacionObjetivosConfiguracionListaEmpleado/${id}/`,
      {
        headers: { "Content-Type": "application/json" },
      }
    ); */
}

export default new ConfSmartServices();
